import { createAsyncThunk } from "@reduxjs/toolkit";
import { GetPendingApproval } from 'api/dashboard/taskmanager-api';

const getPendingApproval = createAsyncThunk('/dashboard/taskmanager', async()=>{
    const response = await GetPendingApproval()
    return response
})

export {getPendingApproval}